import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 13.1024 12.494",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M0.107422 5.09537C-0.101411 4.90225 0.0120271 4.55312 0.294492 4.51963L4.29687 4.04509C4.412 4.03145 4.51199 3.95891 4.56055 3.85364L6.2487 0.193735C6.36784 -0.0645561 6.73503 -0.0645892 6.85417 0.193701L8.54232 3.85369C8.59087 3.95896 8.69022 4.03145 8.80534 4.0451L12.8079 4.51963C13.0904 4.55312 13.2038 4.90227 12.9949 5.09539L10.0361 7.83189C9.95095 7.91059 9.91295 8.02791 9.93555 8.14162L10.7209 12.0948C10.7763 12.3738 10.4794 12.5896 10.2312 12.4506L6.7143 10.482C6.61314 10.4254 6.48992 10.4253 6.38876 10.482L2.87151 12.4507C2.6233 12.5896 2.32608 12.3738 2.38151 12.0949L3.16703 8.14158C3.18962 8.02787 3.15167 7.91063 3.06656 7.83192L0.107422 5.09537Z",
		fill: "var(--fill-0, #324051)"
	})
});
export default SvgStar;
